import { render, staticRenderFns } from "./growthModelHisParamControlNumerical.vue?vue&type=template&id=83042d16&scoped=true"
import script from "./growthModelHisParamControlNumerical.vue?vue&type=script&lang=js"
export * from "./growthModelHisParamControlNumerical.vue?vue&type=script&lang=js"
import style0 from "./growthModelHisParamControlNumerical.vue?vue&type=style&index=0&id=83042d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83042d16",
  null
  
)

export default component.exports